import React from 'react';
import { useTranslation } from 'react-i18next';
import Checkmark from "../../../../public/images/green-checkmark.svg";

import styles from './styles.module.scss';
import ModalLayout from 'app/components/Layouts/ModalLayout/ModalLayout';

type PropsDef = {
  isOpen: boolean;
  onClose: () => void;
};

export default function ProgramDeletedSuccessModal(props: PropsDef) {
  const { isOpen, onClose } = props;
  const { t } = useTranslation();

  return (
    <ModalLayout isOpen={isOpen} onClose={onClose} classNames={`${styles.modal}`}>
      <div className={styles.confirmation_modal_content}>
        <div className={styles.title_and_content}>
          <div className={styles.title}>
            <img src={Checkmark} width={40} height={40} />
            <h2>{t("Program deleted successfully")}</h2>
          </div>
          <div className={styles.button}>
            <button onClick={onClose} className={`${styles.confirm_button} btn btn-primary`}>
              {t("Ok")}
            </button>
          </div>
        </div>
      </div>
    </ModalLayout>
  );
}
